import { Box, Image } from '@chakra-ui/react';

import { attachmentText } from 'Const/reschedule/text';

import getProductImage from 'View/host-stock-promo/helper/getProductImage';
import { useStockPromoState } from 'View/stock-promo/state';

import styles from './styles.module.css';

const ColumnImage = ({ image }) => {
  const { updateState } = useStockPromoState();

  
  const imageUrl = getProductImage(image);

  const handleThumbnailClick = () => updateState({ isOpenImagePreview: true, selectedImagePreview: [imageUrl] });

  return (
    <Box className={styles['column-image__container']} onClick={handleThumbnailClick}>
      <Image src={imageUrl} alt={attachmentText.alt} className={styles['column-image']} objectFit="cover" />
    </Box>
  );
};

export default ColumnImage;
